export default {"src":"/_next/static/media/mobile-method.66072ac5.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};